import { SpendLevelType } from '../../api/rfps/rfpOffers.service';

/**
 * @description: Takes in an spendLevelType and an object with the fieldName from the spendLevelType
 * and formats the value for display on the frontend
 * @param: spendLevel - object from service object with a fieldNames property
 * @param: dataObject - an object that has the fields witht he fieldNames from the spendLevel object
 * @return string - formatter for display
 */
export default function SpendLevelValue($filter) {
  'ngInject';
  // currently only works for targetSpendLevel object - see warning note above
  return (spendLevel: SpendLevelType | null, dataObject: any): string => {
    // not exactly sure why fieldNames is an array
    const fieldName = spendLevel?.fieldNames[0];
    const rawValue = dataObject && dataObject[fieldName];
    let returnValue;

    switch (spendLevel?.name) {
      case 'ABSOLUTE_DOLLARS':
        returnValue = $filter('nfcurrency')(rawValue);
        break;
      case 'ABSOLUTE_UNITS':
        returnValue = $filter('numberOrNA')(rawValue);
        break;
      case 'DOLLAR_MARKET_SHARE':
      case 'UNIT_MARKET_SHARE':
        returnValue = $filter('percentage')(rawValue);
        break;
    }

    if (!returnValue) {
      return 'N/A';
    }
    return returnValue;
  };
}
